'use client';

import { TocNav, type TocNavProps } from '@highereducation/hen-ui';
import {
  personalDataAllowed,
  useAccountState,
} from '@hen-site/lib/auth/accountState';

type AuthAwareTocNavProps = TocNavProps & {
  /** Tenant slug. Absent means the save control stays hidden. */
  tenant?: string;
};

/**
 * Gates the save control on the shared account state.
 * The first render keeps it hidden so cached HTML stays identity-free.
 * A local environment with auth disabled still shows the control.
 */
export default function AuthAwareTocNav({
  tenant,
  showSaveButton: tenantAllowsSaveButton = true,
  ...tocNavProps
}: AuthAwareTocNavProps) {
  const account = useAccountState();
  const showSaveButton =
    Boolean(tenant) &&
    tenantAllowsSaveButton &&
    (personalDataAllowed(account) || account.authDisabled);

  return <TocNav {...tocNavProps} showSaveButton={showSaveButton} />;
}
